import { Button, Col, Form, Row, Select } from "antd";
import FloatDatePicker from "../../../common/components/FloatDatePicker";
import { FloatInput, FloatInputNumber, FloatSelect } from '../../../common/components/Index';
import { AuctionRegisterHistorySearch } from "../../types";
import moment from 'moment';
import { endOfDay, format, startOfDay } from "date-fns";
import { useLazyGetProductCategoryListQuery } from "../../../../redux/api/SystemApi";
import { useEffect } from "react";
import { contractTypes } from "../../../common/types/types";

const { Option } = Select;

interface FilterProps {
    setSubmitValue: React.Dispatch<React.SetStateAction<AuctionRegisterHistorySearch | undefined>>,
    triggerSearch: (submitValue: AuctionRegisterHistorySearch) => void,
    statusContract: number,
}

const AuctionRegisterHistoryFilter = ({ setSubmitValue, triggerSearch, statusContract }: FilterProps) => {
    const [form] = Form.useForm();
    const [trigger, response] = useLazyGetProductCategoryListQuery();

    useEffect(() => {
        trigger({ page: 0, size: 1000, isPublic: 1 })
    }, [trigger])

    const onReset = () => {
        setSubmitValue({});
        form.resetFields();
    }

    const onValuesChange = (changedValues: any, allValues: any) => {
        let toDateValue = form.getFieldValue("toDate");
        if (changedValues.fromDate && toDateValue && changedValues.fromDate > toDateValue) {
            form.setFieldsValue({
                toDate: ""
            })
        }
    }

    const onFinish = (values: any) => {
        let submitValue: AuctionRegisterHistorySearch = {
            ...values.productName ? { productName: values.productName.trim() } : {},
            ...values.productCode ? { productCode: values.productCode.trim() } : {},
            ...values.startStatus ? { startStatus: values.startStatus } : {},
            ...values.categoryCode ? { categoryCode: values.categoryCode } : {},
            ...values.fromDate ? { fromDate: format(startOfDay(values.fromDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.toDate ? { toDate: format(endOfDay(values.toDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.fromStartPrice ? { startPriceBegin: values.fromStartPrice } : {},
            ...values.toStartPrice ? { startPriceTo: values.toStartPrice } : {},
            ...values.fromDateContract ? { fromDateContract: format(startOfDay(values.fromDateContract), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.toDateContract ? { toDateContract: format(endOfDay(values.toDateContract), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
            ...values.statusContract ? { statusContract: values.statusContract } : {},
        };

        setSubmitValue(submitValue);
        triggerSearch(submitValue);
    }

    const disabledDate = (date: moment.Moment) => {
        return (date && date < moment(0))
    }

    return (
        <Form
            className="custom-form"
            name="register"
            form={form}
            colon={false}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            style={{ background: 'white', padding: 15, borderRadius: 15 }}
        >
            <div className="font-size-16 font-bold">Tên tài sản</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="productName"
                        style={{ marginBottom: 0 }}>
                        <FloatInput label="" placeholder="Nhập tên tài sản cần tìm" className="filter-input" maxLength={200} allowClear/>
                    </Form.Item>
                </Col>
            </Row>

            {statusContract ?
                <>
                    <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Mã tài sản</div>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={24}>
                            <Form.Item
                                name="productCode"
                                style={{ marginBottom: 0 }}>
                                <FloatInput label="" placeholder="Nhập mã tài sản cần tìm" className="filter-input" maxLength={100} allowClear />
                            </Form.Item>
                        </Col>
                    </Row>
                </> : <></>
            }

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Nhóm tài sản</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="categoryCode"
                        style={{ marginBottom: 0 }}>
                        <FloatSelect
                            allowClear
                            label=""
                            placeholder="Chọn nhóm tài sản"
                            className="custom-select filter-select">
                            {response.data?.content?.map(item => (
                                <Option key={item.categoryId} value={item.productCategoryCode}>{item.name}</Option>
                            ))}
                        </FloatSelect>
                    </Form.Item>
                </Col>
            </Row>

            {!statusContract ?
                <>
                    <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Trạng thái ký hợp đồng</div>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={24}>
                            <Form.Item
                                name="statusContract"
                                style={{ marginBottom: 0 }}>
                                <FloatSelect
                                    allowClear
                                    label=""
                                    placeholder="Chọn trạng thái ký hợp đồng"
                                    className="custom-select filter-select">
                                    <Option value={contractTypes.NOTSUBMIT}>Chưa tiếp nhận</Option>
                                    <Option value={contractTypes.PROCESSING}>Đang xử lý</Option>
                                    <Option value={contractTypes.DENY}>Không ký hợp đồng</Option>
                                </FloatSelect>
                            </Form.Item>
                        </Col>
                    </Row>
                </> : <></>}

            {statusContract ?
                <>
                    <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Trạng thái đấu giá</div>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={24}>
                            <Form.Item
                                name="startStatus"
                                style={{ marginBottom: 0 }}>
                                <FloatSelect
                                    allowClear
                                    label=""
                                    placeholder="Chọn trạng thái đấu giá"
                                    className="custom-select filter-select">
                                    <Option value={1}>Sắp diễn ra</Option>
                                    <Option value={2}>Đang diễn ra</Option>
                                    <Option value={3}>Đang tạm dừng</Option>
                                    <Option value={4}>Đã kết thúc</Option>
                                </FloatSelect>
                            </Form.Item>
                        </Col>
                    </Row>
                </> : <></>}

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Thời gian đăng ký bán tài sản</div>
            <Row style={{ marginTop: 5 }} gutter={10}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="fromDateContract"
                        style={{ marginBottom: 0 }}>
                        <FloatDatePicker label="" placeholder="Từ ngày" className="filter-picker" disabledDate={disabledDate} allowClear />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="toDateContract"
                        style={{ marginBottom: 0 }}
                    >
                        <FloatDatePicker
                            allowClear
                            label=""
                            placeholder="Đến ngày"
                            className="filter-picker"
                            disabledDate={(current) => {
                                return current && current < form.getFieldValue("fromDate")
                            }} />
                    </Form.Item>
                </Col>
            </Row>

            {statusContract ?
                <>
                    <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Thời gian tài sản đấu giá</div>
                    <Row style={{ marginTop: 5 }} gutter={10}>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                name="fromDate"
                                style={{ marginBottom: 0 }}>
                                <FloatDatePicker label="" placeholder="Từ ngày" className="filter-picker" disabledDate={disabledDate} allowClear />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                name="toDate"
                                style={{ marginBottom: 0 }}
                            >
                                <FloatDatePicker
                                    allowClear
                                    label=""
                                    placeholder="Đến ngày"
                                    className="filter-picker"
                                    disabledDate={(current) => {
                                        return current && current < form.getFieldValue("fromDate")
                                    }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </> : <></>
            }

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Giá khởi điểm</div>
            <Row style={{ marginTop: 5 }} gutter={10}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="fromStartPrice"
                        style={{ marginBottom: 0 }}>
                        <FloatInputNumber
                            label=""
                            className="filter-input"
                            placeholder="Từ giá"
                            controls={false}
                            style={{ border: "none", display: 'flex', alignItems: 'center', width: '100%', background: "#ECECEC" }}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                            parser={value => Number(value?.replace(/\$\s?|(\.*)/g, ''))} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="toStartPrice"
                        style={{ marginBottom: 0 }}
                        dependencies={["fromStartPrice"]}
                        rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('fromStartPrice') <= value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Giá không hợp lệ'));
                                },
                            })
                        ]}>
                        <FloatInputNumber
                            label=""
                            className="filter-input"
                            placeholder="Đến giá"
                            controls={false}
                            style={{ border: "none", display: 'flex', alignItems: 'center', width: '100%', background: "#ECECEC" }}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                            parser={value => Number(value?.replace(/\$\s?|(\.*)/g, ''))} />
                    </Form.Item>
                </Col>
            </Row>

            <Row style={{ marginTop: 30 }} align="middle" gutter={10}>
                <Col span={12}>
                    <Button className="button-gray" style={{ height: 45 }} block onClick={onReset}>NHẬP LẠI</Button>
                </Col>
                <Col span={12}>
                    <Button className="button-light-yellow" style={{ height: 45 }} block htmlType="submit">TÌM KIẾM</Button>
                </Col>
            </Row>
        </Form >
    )
}

export default AuctionRegisterHistoryFilter;